import { gql } from '__generated__'

/**
 * Demo Bull's Eye rounds of the caller's demo session: read by the guest
 * claim (FE-310) and by the demo mode itself. `roundsLimit` / `roundsLeft`
 * are `null` for a session without a limit (a signed-in user's own session).
 */
export const GET_DEMO_BULLSEYE_QUOTA = gql(`
  query getDemoBullseyeQuota {
    getDemoBullseyeQuota {
      enabled
      registered
      roundsLimit
      roundsPlayed
      roundsLeft
      canPlay
    }
  }
`)
